"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DividerDecorative = void 0;
var react_1 = __importDefault(require("react"));
var icons_1 = require("../icons");
var DividerDecorative = function (_a) {
    var color = _a.color, className = _a.className;
    var classes = ['divider-decorative', className].filter(Boolean).join(' ');
    return (react_1.default.createElement("div", { className: classes, style: color ? { color: color } : undefined },
        react_1.default.createElement("span", { className: "divider-decorative__line" }),
        (0, icons_1.makeIcon)('star-ai', '16px'),
        react_1.default.createElement("span", { className: "divider-decorative__line" })));
};
exports.DividerDecorative = DividerDecorative;
